import { useAuthContext } from "../../hooks/auth/AuthContext";
import { useSettingsContext } from "../../hooks/settings/SettingsContext";
import styled from "styled-components";
import Furigana from "../furigana.js";
import Typography from "@mui/material/Typography";
import ToggleButton from "@mui/material/ToggleButton";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";

const StyledMainBox = styled(Box)`
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 200px;
`;

const StyledBox = styled(Box)`
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

const StyledExemple = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

const StyledElement = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Settings = () => {
  const { } = useAuthContext();
  const { furigana, romanji, admin, setFurigana, setRomanji, setAdmin } = useSettingsContext();

  return (
    <StyledMainBox>
      <StyledBox>
        <StyledExemple>
          <StyledElement>
            <Furigana text={furigana ? "[日本語=にほんご]" : "日本語"} />
            {romanji && (
              <Typography variant="subtitle2" sx={{ color: "#ffffff80" }}>
                nihongo
              </Typography>
            )}
          </StyledElement>
        </StyledExemple>
      </StyledBox>
      <StyledBox>
        <Typography variant="body1">Furigana:</Typography>
        <ToggleButton size="small" value={furigana} selected={furigana} onChange={() => setFurigana((prevSelected) => !prevSelected)}>
          <CheckIcon />
        </ToggleButton>
      </StyledBox>
      <StyledBox>
        <Typography variant="body1">Romanji:</Typography>
        <ToggleButton size="small" value={romanji} selected={romanji} onChange={() => setRomanji((prevSelected) => !prevSelected)}>
          <CheckIcon />
        </ToggleButton>
      </StyledBox>
    </StyledMainBox>
  );
};

export default Settings;
